import dayjs from 'dayjs';

function parsePaymentStatus(status) {
  switch (status) {
    case 'paying':
      return 'pagando';
    case 'paid':
      return 'pago';
    case 'refunded':
      return 'devolvido';
    default:
      return null;
  }
}

function isRecentPayment(payment) {
  return dayjs(payment.confirmed_at).add(4, 'hours').isAfter(dayjs());
}

export { parsePaymentStatus, isRecentPayment };
